import React, { useEffect, useState } from 'react'
import './InitialAssessmentReport.css'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'
const InitialAssessmentReportManual = () => {
  const [data, setData] = useState(null)
  const [claimData, setClaimData] = useState(null)
  const { claimNumber } = useParams()
  console.log('7', claimNumber)

  const navigate = useNavigate()

  const handleApproveClick = () => {
    navigate(`/approve-claim/${claimNumber}`)
  }
  const handleManualqcClick = () => {
    navigate(`/manual-qc/${claimNumber}`)
  }
const [progressData, setProgressData] = useState({})

  useEffect(() => {
    const fetchProgress = async () => {
      if (claimNumber) {
        try {
          const res = await axios.post(
            `/process_data/claim_progress/${claimNumber}`
          )
          setProgressData(res.data)
          console.log('progress-32', res.data)
        } catch (err) {
          console.error('Error fetching claim progress:', err)
        }
      }
    }
    fetchProgress()
  }, [claimNumber])
 useEffect(() => {
  if (!claimNumber || !progressData) return;

  if (progressData.pre_invoice == '1') {
    console.log("43-pre-invoice-extract");

    axios
      .post(`/server/get-pre-invoice-data/${claimNumber}`)
      .then(response => {
        console.log('pre-invoice data', response.data)
        setData(response.data)
      })
      .catch(error => console.error('Axios error:', error));
  } else {
    console.log("54-invoice-extract");

    axios
      .post(`/server/get-invoice-data/${claimNumber}`)
      .then(response => {
        console.log('invoice data', response.data)
        setData(response.data)
      })
      .catch(error => console.error('Axios error:', error));
  }
}, [claimNumber, progressData]);
  // useEffect(() => {
  //   if (claimNumber) {
  //     axios
  //       .post(`/server/get-invoice-data/${claimNumber}`)
  //       .then(response => {
  //         console.log('data', response.data)
  //         setData(response.data)
  //       })
  //       .catch(error => console.error('Axios error:', error))
  //   }
  // }, [claimNumber])
  useEffect(() => {
    if (claimNumber) {
      axios
        .post(`/server/get-claim-data/${claimNumber}`)
        .then(response => {
          console.log('claimData', response.data)
          setClaimData(response.data)
        })
        .catch(error => console.error('Axios error:', error))
    }
  }, [claimNumber])
  const calculateRow = row => {
    const qty = Number(row.qty)
    const rate = Number(row.rate)
    const taxPercent = Number(row.taxPercent)
    const depPercent = Number(row.depPercent)

    const taxable = qty * rate
    const taxAmount = (taxable * taxPercent) / 100
    const total = taxable + taxAmount
    const depAmount = (taxable * depPercent) / 100

    return { taxable, taxAmount, total, depAmount }
  }
  const subtotal = data?.parts?.reduce(
    (acc, row) => {
      const { taxable, taxAmount, total, depAmount } = calculateRow(row)
      acc.taxable += taxable
      acc.taxAmount += taxAmount
      acc.total += total
      acc.depAmount += depAmount
      return acc
    },
    { taxable: 0, taxAmount: 0, total: 0, depAmount: 0 }
  ) || { taxable: 0, taxAmount: 0, total: 0, depAmount: 0 }

  // if (!data) return <div>Loading...</div>;
  const combinedData = { ...(claimData || {}), ...(data || {}) }
  console.log('combinedData', combinedData)
  if (!data || !claimData) return <div>Loading...</div>
  return (
    <div className='report-container'>
      <div className='report-header'>
        <img
          src='/custom-icons/surveyorIcon.png'
          alt='Surveyor AI Logo'
          className='logo'
        />
        <div className='report-title'>
          <h2>Initial Claim Assessment Report</h2>
        </div>
        <p className='printed-date'>
          Printed:{' '}
          {new Date().toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          })}
        </p>
      </div>

      <div className='inline-box-row'>
        <div className='inline-box label'>Policy Number</div>
        <div className='inline-box value'>
          {combinedData.policyNumber || '--'}
        </div>
        <div className='inline-box label'>Claim Number</div>
        <div className='inline-box value'>
          {combinedData.claimNumber || '--'}
        </div>
        <div className='inline-box label'>Ticket Number</div>
        <div className='inline-box value'>
          {combinedData?.workshop_details?.ticket_number || '--'}
        </div>
      </div>

      <div className='inline-box-row info-box'>
        <div className='info-full-row'>
          <div className='inline-box label'>Date:</div>
          <div className='inline-box value'>
            {new Date().toLocaleString('en-IN', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              hour12: true
            })}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Name of Owner:</div>
          <div className='inline-box value'>{combinedData.insured || '--'}</div>
          <div className='inline-box label'>Engine No.:</div>
          <div className='inline-box value'>
            {combinedData.EngineNumber || '--'}
          </div>
          <div className='inline-box label'>Workshop Name:</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.workshop_name || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Registration No.:</div>
          <div className='inline-box value'>
            {combinedData.VehicleRegistrationNumber || '--'}
          </div>
          <div className='inline-box label'>Surveyor Name:</div>
          <div className='inline-box value'>Not Mentioned</div>
          <div className='inline-box label'>Workshop GST Number:</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.workshop_gst_number || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Date of Reg.:</div>
          <div className='inline-box value'>
            {combinedData.DateofRegistration || '--'}
          </div>
          <div className='inline-box label'>Claim Coordinator:</div>
          <div className='inline-box value'>--</div>
          <div className='inline-box label'>Date of Accident:</div>
          <div className='inline-box value'>
            {combinedData.dateOfAccident || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Make & Model:</div>
          <div className='inline-box value'>
            {combinedData.Make || '--'} {combinedData.Variant || ''}
          </div>
          <div className='inline-box label'>Chassis No.:</div>
          <div className='inline-box value'>
            {combinedData.ChassisNumber || '--'}
          </div>
          <div className='inline-box label'>Vehicle Age (Years):</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.vehicle_age || '--'}
          </div>
        </div>

        <div className='info-row'>
          <div className='inline-box label'>Payment to:</div>
          <div className='inline-box value'>
            {combinedData?.workshop_details?.payment_to || '--'}
          </div>
        </div>
      </div>

      <div className='note-section'>
        <p>
          "Please find the below tentative estimation for the subject vehicle as
          per the visible damages..."
        </p>
        <p>
          <strong>Important Notes:</strong>
        </p>
        <ul>
          <li>
            After completion of repair, you shall submit the vehicle for
            reinspection...
          </li>
          <li>
            Final tax invoice raised in favor of Surveyor Insurance Limited...
          </li>
        </ul>
        {/* <p className='help-note'>
          For any further clarifications regarding your claim: Contact TPA at
          support@insurancecompany.com or +91 9810498126
        </p> */}
         <p className='help-note'>
          For any further clarifications regarding your claim: Contact TPA
          at&nbsp;
          {/* {formData.email_id || ' support@tpa.com'} or{' '}
          {formData.phone_number || ' +91-XXXXX-XXXXX'} */}
           {'surveyor@surveyor.com'} or {' +91-9876543210'}
        </p>
      </div>
            {/* remove job and material columns from parts table */}
      <h4 className='section-heading'>PARTS</h4>
      <table className='parts-table'>
        <thead>
          <tr>
            <th>SN</th>
            {/* <th>JOB</th> */}
            <th>MATERIAL</th>
            <th>DESCRIPTION</th>
            <th>HSN</th>
            <th>QTY</th>
            <th>PART RATE</th>
            <th>TAXABLE AMOUNT</th>
            <th>TAX (%)</th>
            <th>TAX AMOUNT</th>
            <th>TOTAL AMOUNT</th>
            <th>DEP (%)</th>
            <th>DEP AMOUNT</th>
            <th>R&R CHARGES</th>
            <th>REPAIR CHARGES</th>
            <th>PAINTING CHARGES</th>
          </tr>
        </thead>
        <tbody>
          {combinedData?.parts?.map((part, i) => {
            const qty = Number(part.qty || 0)
            const rate = Number(part.rate || 0)
            const taxPercent = Number(part.taxPercent || 0)
            const depPercent = Number(part.depPercent || 0)
            const taxableAmount = qty * rate
            const taxAmount = (taxableAmount * taxPercent) / 100
            const totalAmount = taxableAmount + taxAmount
            const depAmount = (taxableAmount * depPercent) / 100

            return (
              <tr key={i}>
                <td>{i + 1}</td>
                {/* <td>{part.job}</td> */}
                <td>{part.material}</td>
                <td>{part.description}</td>
                <td>{part.hsn}</td>
                <td>{part.qty}</td>
                <td>{part.rate}</td>
                <td>₹{taxableAmount.toFixed(2)}</td>
                <td>{part.taxPercent}</td>
                <td>₹{taxAmount.toFixed(2)}</td>
                <td>₹{totalAmount.toFixed(2)}</td>
                <td>{part.depPercent}</td>
                <td>₹{depAmount.toFixed(2)}</td>
                <td>₹{part.rrCharges}</td>
                <td>₹{part.repairCharges}</td>
                <td>₹{part.paintingCharges}</td>
              </tr>
            )
          })}
          {combinedData?.parts && (
            <tr className='subtotal-row'>
              <td colSpan='7'>
                <strong>Subtotal</strong>
              </td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => sum + Number(p.qty) * Number(p.rate), 0)
                  .toFixed(2)}
              </td>
              <td></td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => {
                    const taxBase = Number(p.qty) * Number(p.rate)
                    return sum + (taxBase * Number(p.taxPercent)) / 100
                  }, 0)
                  .toFixed(2)}
              </td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => {
                    const taxBase = Number(p.qty) * Number(p.rate)
                    const taxAmount = (taxBase * Number(p.taxPercent)) / 100
                    return sum + taxBase + taxAmount
                  }, 0)
                  .toFixed(2)}
              </td>
              <td></td>
              <td>
                ₹
                {combinedData.parts
                  .reduce((sum, p) => {
                    const taxBase = Number(p.qty) * Number(p.rate)
                    return sum + (taxBase * Number(p.depPercent)) / 100
                  }, 0)
                  .toFixed(2)}
              </td>
              <td colSpan='5'></td>
            </tr>
          )}
        </tbody>
      </table>

      <h4 className='section-heading'>LABOUR</h4>
      <table className='labor-table'>
        <thead>
          <tr>
            <th>LABOUR TYPE</th>
            <th>TAXABLE AMOUNT</th>
            <th>TAX AMOUNT</th>
            <th>TOTAL AMOUNT</th>
            <th>DEP AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {combinedData?.labour_details?.length > 0 ? (
            combinedData.labour_details.map((labour, index) => {
              const taxable = Number(labour.taxable_amount || 0)
              const tax = Number(labour.tax_amount || 0)
              const total = Number(labour.total_amount || 0)
              const dep = Number(labour.dep_amount || 0)

              return (
                <tr key={index}>
                  <td>{labour.labour_type || '--'}</td>
                  <td>₹{taxable.toFixed(2)}</td>
                  <td>₹{tax.toFixed(2)}</td>
                  <td>₹{total.toFixed(2)}</td>
                  <td>₹{dep.toFixed(2)}</td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan='5'>No labour details available</td>
            </tr>
          )}
        </tbody>
      </table>

      <h4 className='section-heading'>FINAL CALCULATION</h4>
      <table className='final-table'>
        <thead>
          <tr>
            <th>FINAL CALCULATION</th>
            <th>AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total Liability</td>
            <td>{combinedData?.final_calculation?.total_liability || '--'}</td>
          </tr>
          <tr>
            <td>Compulsory Deductible</td>
            <td>
              {combinedData?.final_calculation?.compulsory_deductable || '--'}
            </td>
          </tr>
          <tr>
            <td>Voluntary Deductible</td>
            <td>
              {combinedData?.final_calculation?.voluntary_deductible || '--'}
            </td>
          </tr>
          <tr>
            <td>Salvage Deductions</td>
            <td>
              {combinedData?.final_calculation?.salvage_deductions || '--'}
            </td>
          </tr>
          <tr>
            <td>Non-Standard Amount</td>
            <td>
              {combinedData?.final_calculation?.non_standard_amount || '--'}
            </td>
          </tr>
          <tr>
            <td>Towing Amount</td>
            <td>{combinedData?.final_calculation?.towing_amount || '--'}</td>
          </tr>
          <tr className='total-row'>
            <td>Liability</td>
            <td>{combinedData?.final_calculation?.digit_liability || '--'}</td>
          </tr>
        </tbody>
      </table>

      <div className='note-section'>
        <div className='section-heading'>ASSESSMENT NOTES</div>
        <ul className='assessment-notes'>
          <li>
            Any additional amount over and above the approved assessment shall
            be borne by the Insured.
          </li>
          <li>
            The final liability has been arrived at as full and final settlement
            after consent from the Insured...
          </li>
        </ul>
      </div>

      <div className='button-group'>
        <button className='approve-btn' onClick={handleApproveClick}>
          Approve
        </button>
        <button className='manual-btn' onClick={handleManualqcClick}>
          Manual QC
        </button>
      </div>
    </div>
  )

}

export default InitialAssessmentReportManual
